import { Component, Injector, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BasePageComponent } from '../base.page';
@Component({
    selector: 'app-page-placeholder-subnav',
    templateUrl: './placeholder-subnav.page.html',
    styleUrls: ['./placeholder-subnav.page.scss'],
})
export class PlaceholderSubnavPage extends BasePageComponent implements OnInit {
    background: string = '#0076bf';
    navLinks = [
        {
            label: 'Subanv 1',
            link: 'contentblocks',
            index: 0,
        },
        {
            label: 'Subnav 2',
            link: 'variables',
            index: 1,
        },
        {
            label: 'Subnav 3',
            link: 'teamplates',
            index: 2,
        },
    ];
    activeLink = this.navLinks[0].link;
    constructor(injector: Injector, protected override router: Router) {
        super(injector);
    }

    override ngOnInit() {
        super.ngOnInit();
    }
}
